export const formatCount = (value: number): string =>
  value.toLocaleString('en-US');

export const plural = (count: number, one: string, many: string): string =>
  count === 1 ? one : many;

export const widthPercent = (part: number, whole: number): string =>
  `${whole > 0 ? (Math.max(0, part) / whole) * 100 : 0}%`;

export const validDate = (value?: string): Date | null => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};
